<template>
	<b-card>
        <b-row style="margin-top: 25px;">
            <b-col sm="5" md="6" class="my-1">
			    <b-form-group
			        label="Per page"
			        label-cols-sm="6"
			        label-cols-md="4"
			        label-cols-lg="3"
			        label-align-sm="right"
			        label-size="sm"
			        label-for="perPageSelect"
			        class="mb-0"
			    >
				    <b-form-select
				          v-model="perPage"
				          id="perPageSelect"
				          size="sm"
				          :options="pageOptions"
				    ></b-form-select>
			    </b-form-group>
			</b-col>
			    <b-col sm="7" md="6" class="my-1">
			      	<b-pagination
				        v-model="currentPage"
				        :total-rows="items.length"
				        :per-page="perPage"
				        align="fill"
				        size="sm"
				        class="my-0"
				     ></b-pagination>
			    </b-col>
		</b-row>
		<!-- <div id="mut_freq" class="mt-3" v-if="mut_info != null" :style="displaydiv"> -->
		    <b-table striped hover 
		    :items="items" 
		    :fields="fields_details"
		    :current-page="currentPage"
		    :per-page="perPage">
		    </b-table>
		<!-- </div> -->
	</b-card>
</template>

<script>
	export default {
 		props: {
 			items: Array,
 		},
        data(){
            return {
                
                freq_info:Array,
                fields_details: [
                          {label: 'Entry Name', key: 'entry_name', sortable: true},
                          {label: 'Gene', key: 'gene', sortable: true},
                          {label: "HGVSP", key: 'hgvsp'},
                          {key: 'af', label: 'Frequency (GnomAD)', sortable: true}
                        ],
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 25, 50],
            }
        },
    };
</script>